<template>
  <v-dialog v-model="contactDialog" max-width="840" persistent>
    <v-card max-width="875" class="px-3 py-3">
      <v-card-title class="section-title py-6"> Novo número Whatsapp </v-card-title>
      <v-card-subtitle class="subtitle">
        O mesmo número pode estar atrelado a várias lojas, mas uma loja pode ter apenas um número. Para criar um número, basta preecher as informações abaixo:
      </v-card-subtitle>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="8">
            <v-text-field
              ref="phone"
              v-model="whatsappNumber"
              v-mask="'(##) #####-####'"
              class="py-3"
              return-masked-value
              :error-messages="errorPhone"
              outlined
              placeholder="(41) 99999 9999"
              label="Número do celular "
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="8">
            <v-text-field v-model="suggestedMessage" class="py-3" outlined placeholder="Mensagem sugerida" :error-messages="errorWppMessage"></v-text-field>
          </v-col>
          <v-col class="pt-6 pl-4">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <mf-icon small color="cinza-0">error</mf-icon>
                </span>
              </template>
              <span
                >Quando seu usuário é direcionado<br />para o whatsapp, uma mensagem é<br />sugerida a ele para envio. Quem<br />define essa mensagem é
                você.</span
              >
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row no-gutters align="center">
          <v-checkbox
            v-model="showInHotsite"
            :disabled="disabledWhatsappCheckbox"
            color="primary"
            class="pr-3"
            label="Usar este número no site de cadastramento"
          />
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <mf-icon small color="cinza-0">error</mf-icon>
              </span>
            </template>
            <span
              >Apenas um número pode ser utilizado <br />
              simultaneamente. Se a caixa de seleção estiver <br />
              desabilitada, confira se outro número já está <br />
              sendo utilizado no site de cadastramento</span
            >
          </v-tooltip>
        </v-row>
        <v-row class="py-3 mt-6" no-gutters>
          <p class="card-title">Lojas onde esse número vai ser exibido:</p>
        </v-row>
        <v-row no-gutters>
          <span v-if="unitError && selectedUnits.length === 0" class="texto-erro mb-1">Selecione uma loja</span>
          <span v-else class="texto-erro">&nbsp;</span>
          <mf-select-units
            ref="selectUnits"
            class="mb-4"
            hide-ecommerce-configuration
            :selected-units.sync="selectedUnits"
            :unavailable-units="unavailableUnitsIds"
            :units="units"
            :tag-list="tagList"
            :data-type.sync="unitFilterType"
            is-section
          />
        </v-row>
        <mf-action-buttons
          :primary-button="{
            text: 'Salvar o número',
            action: save,
            isVisible: true,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: cancel,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
  name: 'WhatsappUnitRegisterModal',
  props: {
    contactDialog: Boolean,
    hasSelectedWhatsapp: Boolean,
    contactInfo: Object,
  },
  data: () => ({
    whatsappNumber: null,
    suggestedMessage: null,
    unitError: false,
    selectedUnits: [],
    showInHotsite: false,
    unitFilterType: {
      includeEcommerceData: true,
      includeOnlyEcommerceData: false,
    },
  }),
  computed: {
    ...mapGetters(['mariaCampaign', 'units', 'tagList', 'unavailableUnitsIds']),
    errorPhone() {
      if (this.$v.whatsappNumber?.$error) return 'Digite um número de telefone válido'
      return ''
    },
    errorWppMessage() {
      if (this.$v.suggestedMessage.$error) return 'Campo obrigatório'
      return ''
    },
    disabledWhatsappCheckbox() {
      return this.hasSelectedWhatsapp && !this.contactInfo.show_in_hotsite
    },
  },
  watch: {
    contactDialog(val) {
      if (val) {
        this.$nextTick(() => {
          this.showInHotsite = this.contactInfo.show_in_hotsite
          if (this.contactInfo.number) {
            const number =
              this.contactInfo.number.substring(0, 2) === '55' ? this.contactInfo.number.slice(2, this.contactInfo.number.length) : this.contactInfo.number
            this.whatsappNumber = number
            this.$refs.phone.$el.getElementsByTagName('input')[0].value = number // não seta adequadamente sem usar o $ref
          } else {
            this.whatsappNumber = null
            this.$refs.phone.$el.getElementsByTagName('input')[0].value = null
          }
          this.suggestedMessage = this.contactInfo.message ? this.contactInfo.message : null
        })
        if (this.contactInfo.units?.length > 0) {
          this.selectedUnits = this.contactInfo.units
        } else {
          this.selectedUnits = []
        }
        if (this.$refs.selectUnits) {
          this.$nextTick(() => {
            this.$refs.selectUnits.checkUnitsOnInit()
          })
        }
        this.$nextTick(() => document.querySelector('.v-dialog').scroll(0, 0))
      }
    },
  },
  methods: {
    cancel() {
      this.selectedUnits = []
      this.$v.$reset()
      this.unitError = false
      this.whatsappNumber = null
      this.suggestedMessage = null
      this.showInHotsite = false
      this.$emit('update:contactDialog', false)
    },
    save() {
      this.$v.$touch()
      if (this.$v.$error) {
        this.$nextTick(() => {
          document.querySelector('.v-dialog').scroll(0, 0)
        })
        return
      }
      this.$v.$reset()
      if (this.selectedUnits.length <= 0) {
        this.unitError = true
        return
      }
      this.unitError = false
      const whatsInfo = {
        number: '55'.concat(this.whatsappNumber.replace(/[^0-9]/g, '')),
        message: this.suggestedMessage,
        units: this.selectedUnits,
        show_in_hotsite: this.showInHotsite,
      }

      this.$emit('saveWhatsappInfo', whatsInfo, this.contactInfo.index)
      this.$emit('update:contactDialog', false)
    },
  },
  validations: {
    whatsappNumber: {
      required,
      minLength: minLength(14),
    },
    suggestedMessage: {
      required,
    },
  },
}
</script>
<style></style>
